import { webPortalApi } from '#config/web-portal-api';
import { getRequestOptions } from '#helper';

let attempt = 1;

const sendMeta = () => {
  const { host, pathname: p, search: s } = window.location;
  const w = window.innerWidth;
  const h = window.innerHeight;

  if (!w && !h && attempt <= 5) {
    attempt += 1;
    return setTimeout(sendMeta, 1000);
  }

  const params = JSON.stringify({
    w: { w, h },
    l: { h: host, p, s },
    m: { atemp: attempt }
  });

  return fetch(webPortalApi.buildUrl('/meta'), {
    headers: {
      ...getRequestOptions().headers,
      Meta: params
    }
  });
};

export const tracking = () => {
  try {
    sendMeta();
  } catch (e) {
    console.error(e);
  }
};
